import React from "react";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import { statusColor } from "../../theme/agendaTheme";
import { i18n } from "../../translate/i18n";

export default function AppointmentStatusBadge({ status }) {
  const label = i18n.t(`appointmentsModule.status.${status}`, { defaultValue: status });
  const color = statusColor(status);
  return (
    <Tooltip title={label}>
      <Chip
        size="small"
        label={label}
        style={{ backgroundColor: color, color: "#fff" }}
      />
    </Tooltip>
  );
}
